import { InitFeatureParams } from '../types'

import { getRoutes } from './routes'

/**
 * 初始化-门户管理-后台
 *
 * @param param - 参数
 * @param param.addRoutes - 添加路由
 */
export const initGatewayManagement = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
